import * as tslib_1 from "tslib";
/* I120 in DS */
// from GDrive, with heavy mods to make less bad
import React from 'react';
import IconWrap from '../IconWrap';
var instances = 0;
var Approve = /** @class */ (function (_super) {
    tslib_1.__extends(Approve, _super);
    function Approve() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.instanceId = instances++;
        return _this;
    }
    Approve.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("mask", { id: "I120-checkMask-" + this.instanceId },
                    React.createElement("rect", { x: "0", y: "0", width: "100", height: "100", fill: "white" }),
                    React.createElement("path", { d: "M12.307 15.707h-1.932v-1.932h1.932V7.979h1.932v7.728h-1.932z", transform: "rotate(45 12.307 11.843)", fill: "black" })),
                React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
                    React.createElement("path", { d: "M12 20a7.998 7.998 0 0 0 8-8 8 8 0 1 0-8 8z", mask: "url(#I120-checkMask-" + this.instanceId + ")" })))));
    };
    return Approve;
}(React.Component));
export default Approve;
//# sourceMappingURL=Approve.js.map